export default __webpack_public_path__ + "static/media/meal-table.45dbe325.svg";